import { Upload, VideoLibrary } from '@mui/icons-material';
import { Link } from '@on3/ui-lib/components/Link';
import { useAuth } from '@on3/ui-lib/index';
import { userHasPermission } from '@on3/ui-lib/utils/auth/access';
import { profileAdmin } from '@on3/ui-lib/utils/auth/constants';
import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';

import styles from './VideosMock.module.scss';

export const VideosMock = () => {
  const { athlete } = useAthlete();
  const { user } = useAuth();
  const canEdit = userHasPermission(profileAdmin, user);

  return (
    <section className={styles.section}>
      <h2>Videos</h2>
      <div className={styles.list}>
        <Link
          className={clsx(styles.placeholder, styles.upload)}
          href={
            canEdit
              ? `/db/${athlete.slug}/elite/network/profile/videos/`
              : `/db/${athlete.slug}/claim-profile/`
          }
        >
          <div>
            <Upload />
            <span>Upload Highlight Video</span>
          </div>
        </Link>
        <div className={styles.placeholder}>
          <VideoLibrary />
        </div>
        <div className={styles.placeholder}>
          <VideoLibrary />
        </div>
      </div>
    </section>
  );
};
